const urlRegex = /(\b(https?|):\/\/[-a-zA-Zа-яА-Я0-9+&@#/%?=~_|!:,.;]*[-a-zA-Zа-яА-Я0-9+&@#/%=~_|])/gi;

const matchUrl = (input: string): readonly string[] => input.match(urlRegex) ?? [];

export default matchUrl;
